import React from 'react';
import { Square, Heading } from '@grubhubprod/gh-cookbook-react/dist';
import { useParams } from 'react-router-dom';
import ManageExemptionCertificates from 'src/components/enterprise/features/TaxExemptions/ManageExemptionCertificates';
import ExemptionCertificateList from 'src/components/enterprise/features/TaxExemptions/ExemptionCertificateList/ExemptionCertificateList';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { useFetchTaxExemptionCertificatesForCorp } from 'src/components/enterprise/features/TaxExemptions/hooks';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { getHomeBreadcrumb } from 'src/constants/urls';

export default function TaxExemptions(): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();
  const { certificates, isLoading } = useFetchTaxExemptionCertificatesForCorp(
    corpid as string
  );
  return (
    <Square inset="lg">
      <PageHeader>
        <Heading variant="h1">Tax Exemptions</Heading>
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Admin home',
              ...getHomeBreadcrumb(corpid),
            },
          ]}
        />
      </PageHeader>
      <ManageExemptionCertificates />
      <ExemptionCertificateList
        isLoading={isLoading}
        certificates={certificates}
      />
    </Square>
  );
}
